<template>
    <div style="font-size:14px;font-weight: 400;color:black" class="pt-10">
        <h1 style="font-size:2.5rem" >Disclaimer & License Information</h1>
        <div style="text-align:left;" class="px-10">
            <strong style="font-weight:600;">Disclaimer</strong>
            <p class="mt-5">The contents of this estimator are presented for informational purposes only, and while effort has been made to ensure their accuracy, they are not to be construed as warranties or guarantees, express or implied, regarding the products or services described herein or their use or applicability.  All sales are governed by our terms and conditions, which are available on request. We reserve the right to modify or improve the designs or specifications of our products at any time without notice.</p>
            
            <strong style="font-weight:600;">Copyright Notices & License Information</strong> <br>
            <div class="ml-5 mt-5 mb-10">
                <span>This product includes Software licensed for distribution under MIT License, such as:</span> <br>
                <ul>
                    <li><a href="https://vuetifyjs.com/en/">Vuetify</a> Copyright © 2016-2022 Vuetify</li>
                    <li><a href="https://vuex.vuejs.org/">Vuex</a> Copyright (c) 2015-present Evan You</li>
                    <li><a href="https://vuejs.org/">Vue</a> Copyright © 2014-2022 Evan You</li>
                </ul>
            </div>
           <p>This product includes fonts licensed for distribution under <a href="https://fonts.google.com/noto/specimen/Noto+Sans/about">Open Font License</a></p>
        </div>
        <a @click="back()">Back ></a>
    </div>  
  </template>
  <script>
  import { fa, tr } from "vuetify/lib/locale";
  import products from "../json/products.json"
  import Navigation from './Navigation.vue'
  
  export default {
    name: 'Disclaimer',
    created(){
        this.$store.state.showDisclaimer = true
    },
    methods:{
        back(){
            this.$router.push('/')
            this.$store.state.showDisclaimer = false
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  h3 {
    margin: 40px 0 0;
  }

  a {
    color: #00AA7E!important;
  }
  .flex-container{
    height: 575px;
    width: 100%;
    display: flex; 
    flex-wrap: wrap;
    padding: 0;
  }
  .white-container{
    margin-left:15px;
    margin-right:15px;
    width:775px;
    height: 365px;
    background-color: white;
    padding: 15px;
    padding-left: 35px;
    padding-top: 25px;
    display: flex;
  }
  .card {
      width: 480px;
      height: 194px;
      cursor: pointer;
      overflow: hidden;
      border-radius: 0;
  }
  .card-container{
    transition: transform .2s ease;
    height: 90px;
    width: 164px;
    display:flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .card-container :hover{
     transform: scale(1.02);
  }
  .hide {
    display: none;
  }
  .title{
    line-height: 15px;
    color: white;
    font-size: 12px!important;
    word-break: keep-all; 
    justify-content: center;
  }
  .header{
    font-size: 14px;
    color: black;
    font-weight:600;
  }
  .col{
    padding: 8px;
    padding-left: 0px;
    padding-right: 0px;
  }
  </style>
  